import "./GiftcardPreviewElement.less";
import { Order, OrderStore } from "./OrderStore";

class GiftcardPreviewElement extends HTMLElement { 
    static tag = "giftcard-preview";
    private _svgLoaded = false;
    private _gameId: string;

    connectedCallback() { 
        
        this.classList.add("box");
        this.toggleAttribute("loading", true);
        this.innerHTML = this.loaderView();
      
        const order = OrderStore.instance.getOrder();

        this._gameId = order.gameId;

        if (this._gameId === "jp-hansen") { 
            this.toggleAttribute("hidden", true);
            return;
        }

        this.toggleAttribute("hidden", order?.isGift === false);
      

        OrderStore.instance.addEventListener("refresh", this.onRefresh);
        OrderStore.instance.addEventListener("gift-message-updated", this.onMessageUpdated);

        if (order.isGift) 
            this.showGiftMessage(order?.giftMessage ?? "");
 
    }

    private loaderView = () => `
        <div class="loader">${require("./Images/loader.svg")}</div>
    `;

    private readonly _parser = new DOMParser();

    private loadRemoteSVG = async () => {     
        console.log("initializer"); 
        this.toggleAttribute("loading", true);

        let giftcardPath;
        switch (this._gameId) { 
            case "mission-possible":
                giftcardPath = require("!!file-loader!./Images/mission-possible-giftcard-template.svg").default;
                break;
            case "pirate-pursuit":
                giftcardPath = require("!!file-loader!./Images/pirate-pursuit-giftcard-template.svg").default;
                break;
            default:
                throw new Error(`Unknown game id: ${this._gameId}`);
        }


        try { 
            const response = await fetch(giftcardPath);
            const rawSVGcontent = await response.text();
            const document = this._parser.parseFromString(rawSVGcontent, "image/svg+xml");

            const errorNode = document.querySelector('parsererror');
            if (errorNode) { 
                console.error("Error parsing SVG", errorNode);
                throw new Error("Error parsing SVG");
            }   

            this.innerHTML = "";
            this.appendChild(document.documentElement);

            
        } finally { 
            this._svgLoaded = true;
            this.toggleAttribute("loading", false);
        }
    }


    private onMessageUpdated = (event: CustomEvent<string>) => { 
        this.showGiftMessage(event.detail);
    }

    private showGiftMessage = async (message: string) => { 
        if (!this._svgLoaded)
            await this.loadRemoteSVG(); 

        this.querySelector("#user-text").innerHTML = this.formatText(message ?? "Enter a giftcard message...");
    }

    private onRefresh = (event: CustomEvent<Order>) => { 
        console.log("refresh", event.detail);

        this.toggleAttribute("hidden", !event.detail.isGift);

        this.showGiftMessage(event.detail.giftMessage);  
    }

    private formatText = (text: string) => { 
        // replace newlines with <br>
        return text.replace(/\n/g, "<br>");
    }
}

customElements.define(GiftcardPreviewElement.tag, GiftcardPreviewElement);